/**
 * Resolve menu/item and API-relative image URLs. Delegates relative paths to {@link resolveCmsImageUri}
 * so storage/uploads use the same origin rules as CMS; keeps any `data:` scheme (not only `data:image/`).
 */
import { resolveCmsImageUri } from './resolveCmsImageUri';

export function resolveImageUri(url: string | undefined): string | null {
  if (url == null || typeof url !== 'string') {
    return null;
  }
  const trimmed = url.trim();
  if (!trimmed) {
    return null;
  }
  if (trimmed.startsWith('data:')) {
    return trimmed;
  }
  return resolveCmsImageUri(url);
}
